import { Injectable } from "@angular/core";
import {CanActivate, CanActivateChild, Router} from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import {DataService} from "@app/shared/data.service";
import {Observable, tap} from "rxjs";
import {map} from "rxjs/operators";
import {jwtDecode} from "jwt-decode";

@Injectable()
export class OnlyMozDozGuard implements CanActivate, CanActivateChild {
  constructor(
      private oauthSvc: OAuthService,
      private dataService: DataService,
      private router: Router
  ) {}

  canActivate(): boolean {
    return this._handler();
  }

  canActivateChild(): boolean {
    return this._handler();
  }

  private _handler(): boolean {
    
    const userRoles = (
        jwtDecode(localStorage['access_token']) as any
    ).realm_access.roles
    
    let isAvailable = userRoles.includes('moz-member-role') || userRoles.includes('doz-member-role') || userRoles.includes('other-member-role')
    
    if (!isAvailable) {
      this.router.navigate(['forbidden']);
    }
    
    return isAvailable
  }
}
